export default function Footer() {
  return (
    <footer
      className="footer mt-auto py-3 bg-light"
      style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        right: 0,
      }}
    >
      <div className="container">
        <ul className="nav justify-content-center border-bottom pb-3 mb-3">
          <li className="nav-item">
            <a
              className="nav-link px-2 text-muted"
              href="https://github.com/EliLillyCo/edat-operations-bot/issues"
              target="_blank"
              rel="noreferrer"
            >
              Report an Issue
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link px-2 text-muted"
              href="https://github.com/EliLillyCo/edat-operations-bot"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a>
          </li>
        </ul>
        <p className="text-center text-muted">© 2021-2022 Eli Lilly & Co</p>
      </div>
    </footer>
  );
}
